@let vm = vm$();

<div class="p-24 h-100 w-100 flex-col gap-24">
  @if (vm.viewState !== 'LOADING' && vm.viewState !== 'INITIAL_EMPTY') {
    <div class="flex-row start-center narrower-input">
      <ui-search
        style="width: 320px;"
        [placeholder]="'SPEAKERS.SEARCH' | translate"
        [searchQuery]="vm.query"
        (onInput)="query.set($event)">
      </ui-search>
    </div>
  }

  @switch (vm.viewState) {
    @case ('LOADING') {
      <div class="h-100 w-100 flex-col center-center">
        <ui-preloader></ui-preloader>
      </div>
    }
    @case ('INITIAL_EMPTY') {
      <div class="h-100 w-100 flex-col center-center">
        <ui-no-data [imgSrc]="noData.imgSrc" [title]="noData.title | translate" [createButtonText]="noData.createButtonText | translate" (onCreate)="navigateToCreate()"></ui-no-data>
      </div>
    }
    @case ('NO_RESULTS') {
      <div class="h-100 w-100 flex-col center-center">
        <ui-no-data [imgSrc]="noResults.imgSrc" [title]="noResults.title | translate"></ui-no-data>
      </div>
    }
    @case ('HAS_DATA') {
      <ui-dataset-table
        class="w-100"
        [data]="vm.filteredSpeakers"
        [config]="tableConfig()"
        (rowAction)="onRowAction($event)">
      </ui-dataset-table>
    }
  }
</div>
